import React from 'react';
import { DashboardProvider, DashboardContext } from '../contexts/DashboardContext';
import { CustomThemeProvider } from '../contexts/ThemeContext';
import { DragDropProvider } from '../contexts/DragDropContext';
import DashboardLayout from '../components/DashboardLayout';

const DashboardPage: React.FC = () => {
  return (
    <DashboardProvider>
      <CustomThemeProvider>
        <DashboardContext.Consumer>
          {(dashboardContext) => (
            <DragDropProvider dashboardContext={dashboardContext}>
              <DashboardLayout />
            </DragDropProvider>
          )}
        </DashboardContext.Consumer>
      </CustomThemeProvider>
    </DashboardProvider>
  );
};

export default DashboardPage; 